































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import {
	Entities,
	EntityStatus,
	FeedApi,
	FeedTank,
	Product,
	ProductOrderStatusEnum,
	ProductsApi,
	ProductStatus,
	Tank,
	TanksApi,
	Vat,
	VatsApi,
	WaterApi,
} from '@/api';
import ConfirmModal from '@/components/display/confirm-modal.vue';
import Toast from '@/components/display/toast.vue';
import { ApiUtils } from '@/common/ApiUtils';
import TooltipButton from './elements/buttons/tooltip-button.vue';
import { getEntityButtonsText } from '@/common/HelpTextUtils';

@Component({
	components: { ConfirmModal, TooltipButton },
	methods: {
		getEntityButtonsText,
	},
	computed: {
		ProductOrderStatusEnum() {
			return ProductOrderStatusEnum;
		},
		EntityStatus() {
			return EntityStatus;
		},
		ProductStatus() {
			return ProductStatus;
		},
	},
})
export default class ConfirmDraftActionbar extends Vue {
	@Prop({ required: true, type: Object })
	public product!: Product;

	@Prop({ required: true, type: String })
	public entityType!: Entities;

	@Prop({ required: true, type: Object })
	public entity!: Vat | Tank | FeedTank;

	@Emit('reload')
	public reload(): void {}

	protected cancelling: boolean = false;
	protected confirming: boolean = false;

	private readonly toast = new Toast();
	private readonly vatsApi = new VatsApi();
	private readonly tanksApi = new TanksApi();
	private readonly feedApi = new FeedApi();
	private readonly waterApi = new WaterApi();
	private readonly productApi = new ProductsApi();

	public async cancel(): Promise<void> {
		if (!this.product?.id || !this.entity?.id) return;

		this.cancelling = true;

		try {
			await this.productApi.changeProductStatus(this.product.id, this.entityType, this.entity.id, {
				newStatus: ProductStatus.Cancelled,
			});
			this.$bvModal.hide('confirm-cancel-draft-product-modal');
			this.toast.makeToast('Successfully cancelled draft entity', 'Success', 'success');
			this.reload();
		} catch (e) {
			const { errorMessage } = ApiUtils.handleApiError(e, 'Unknown error cancelling draft entity');
			this.toast.makeToast(errorMessage, 'Error', 'danger');
		}

		this.cancelling = false;
	}

	public async confirm(): Promise<void> {
		if (!this.entity?.id) return;

		this.confirming = true;

		try {
			switch (this.entityType) {
				case Entities.Vats:
					await this.vatsApi.confirmDraftVat(this.entity.id);
					break;
				case Entities.Tanks:
					await this.tanksApi.confirmDraftTank(this.entity.id);
					break;
				case Entities.FeedTanks:
					await this.feedApi.confirmDraftFeedTank(this.entity.id);
					break;
				case Entities.WaterMeters:
					await this.waterApi.confirmDraftWaterMeter(this.entity.id);
					break;
				case Entities.WaterMonitors:
					await this.waterApi.confirmDraftWaterMonitor(this.entity.id);
					break;
				case Entities.WaterTanks:
					await this.waterApi.confirmDraftWaterTank(this.entity.id);
					break;
			}
			this.$bvModal.hide('confirm-cancel-draft-product-modal');
			this.toast.makeToast(
				'Successfully confirmed draft entity, moved from draft to pending',
				'Success',
				'success',
			);
			this.reload();
		} catch (e) {
			const { errorMessage } = ApiUtils.handleApiError(e, 'Unknown error confirming draft entity');
			this.toast.makeToast(errorMessage, 'Error', 'danger');
		}

		this.confirming = false;
	}
}
